/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CollectionInputs */



/**
* | output |
* | --- |
* | "Collection" |
*
* @param {Nav_CollectionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_collection = /** @type {((inputs?: Nav_CollectionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CollectionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sammlung")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collection")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("收藏")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("收藏")
	if (locale === "ko") return /** @type {LocalizedString} */ ("컬렉션")
	return /** @type {LocalizedString} */ ("Collection")
});